<template>
  <div class="flex flex-col gap-4" v-if="settlementDetails">
    <div class="rounded-lg border border-gray-200 overflow-hidden bg-white">
      <div class="p-6">
        <h2 class="text-lg font-semibold text-gray-900">Settlement Summary</h2>
      </div>
      <div class="border-t border-gray-200">
        <table class="w-full table-auto text-sm text-left">
          <thead class="bg-grey-light-100 text-grey-light-600 font-medium border-b border-gray-200">
            <tr>
              <th class="px-4 py-2">Item</th>
              <th class="px-4 py-2 text-right">Amount</th>
            </tr>
          </thead>
          <tbody class="text-gray-900">
            <tr>
              <td class="p-5 font-medium">Transactions</td>
              <td class="p-5 text-right">{{ currency(settlementDetails?.feesPerPaymentOnlineSettlementAmount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="rounded-lg border border-gray-200 overflow-hidden bg-white">
      <div class="p-6">
        <h2 class="text-lg font-semibold text-gray-900">Fee Summary</h2>
        <p class="text-grey-light-600 text-sm">
          For a more in-depth breakdown of the fees, please
          <span @click="emit('download')" class="text-brand-700 font-semibold hover:cursor-pointer">download</span>
          the report.
        </p>
      </div>
      <div class="border-t border-gray-200">
        <table class="w-full table-auto text-sm text-left">
          <thead class="bg-grey-light-100 text-grey-light-600 font-medium border-b border-gray-200">
            <tr>
              <th class="px-4 py-2">Item</th>
              <th class="px-4 py-2 text-right">Fees - Excl VAT</th>
              <th class="px-4 py-2 text-right">VAT</th>
              <th class="px-4 py-2 text-right">Total Fees - Incl VAT</th>
            </tr>
          </thead>
          <tbody class="text-grey-light-600">
            <template v-if="settlementDetails?.feesPerProduct?.length > 0">
              <tr
                v-for="fee in settlementDetails?.feesPerProduct"
                :key="fee.product._id"
                class="border-b border-gray-200"
              >
                <td class="p-5">{{ fee.product.displayName }}</td>
                <td class="p-5 text-right">{{ currency(fee.amountExcludingVAT) }}</td>
                <td class="p-5 text-right">{{ currency(fee.amountVAT) }}</td>
                <td class="p-5 text-right">{{ currency(fee.amountTotal) }}</td>
              </tr>
            </template>
            <tr>
              <td class="p-5 text-gray-900 font-semibold">Amount Settled</td>
              <td></td>
              <td></td>
              <td class="p-5 text-gray-900 font-semibold text-right">{{ currency(settlementDetails.amount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Settlement } from '@/models/settlements';
import { currency } from '@/utils/format.utils';

defineProps<{
  settlementDetails: Settlement | undefined;
}>();

const emit = defineEmits(['download']);
</script>
